import React from "react";
import { bindActionCreators, Dispatch } from "redux";
import { DashboardLayout } from "component/layout/dashboard";
import { PageProps } from "shared/page-props";
import * as Router from "react-router-dom";
import { RootState } from "redux/store";
import { getOfficeById } from "redux/selector";
import { connect } from "react-redux";
import { OfficeDetailRefresh } from "./office-detail-refresh";

interface Props extends PageProps, 
	Router.RouteComponentProps<RouteParams>,
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps> {
}

interface RouteParams {
	id: string;
}

const getId = (props: Router.RouteComponentProps<RouteParams>) => {
	return parseInt(props.match.params.id);
}

const mapStateToProps = (state: RootState, ownProps: Router.RouteComponentProps<RouteParams>) => {
	const id = getId(ownProps);
	const office = getOfficeById(state, id);
	return {
		office,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

class Component extends React.Component<Props> {

	public render() {
		const { user, office } = this.props;
		// The office name is the page title in the refreshed view, and it is rendered inside the
		// content (below the back link) rather than in the layout header.
		const title = office ? office.name || "Office" : "Office";
		return (
			<DashboardLayout
				permitted={user && user.permissions.broker}
				title={title}
			>
				<>
					{office && (
						<OfficeDetailRefresh office={office} />
					)}
				</>

			</DashboardLayout>
		);
	}

}

export const SettingsOfficePage = connect(mapStateToProps, mapDispatchToProps)(Component);